import configHelper from '@/config/ConfigHelper'
import { i18n } from '@/i18n'

function GenerateConfig () {
  return [
    {
      label: i18n.t('tipos.otp.email'),
      shortlabel: 'EMAIL',
      value: 2,
    },
    {
      label: i18n.t('tipos.otp.otp'),
      shortlabel: 'OTP',
      value: 3,
    },
  ]
}

export function TIPOS_OTP (state) {
  return configHelper.getConfig(state, 'TIPOS_OTP', GenerateConfig)
}
